import { FC } from "react";
import { Listbox } from "@headlessui/react";
import { ChevronDownIcon } from "../../../components/GeneralUI";

export const ListboxButton: FC<{ title: string }> = ({ title }) => (
  <Listbox.Button className="relative flex w-fit cursor-pointer px-3 align-middle text-sm font-medium text-stone-700 dark:text-stone-300">
    {title}
    <ChevronDownIcon />
  </Listbox.Button>
);
